import { render } from "./NewRegistration.vue?vue&type=template&id=272db3f6&scoped=true"
import script from "./NewRegistration.vue?vue&type=script&lang=js"
export * from "./NewRegistration.vue?vue&type=script&lang=js"

import "./NewRegistration.vue?vue&type=style&index=0&id=272db3f6&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/fundraise/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272db3f6"]])

export default __exports__